import { format, parseISO } from "date-fns";
import { AlertOctagon, AlertTriangle, Clock, Archive } from "lucide-react";

export const STATUS_CONFIG = {
  overdue: {
    label: "Overdue",
    icon: AlertOctagon,
    badge: "bg-[hsl(var(--status-overdue)/0.12)] text-[hsl(var(--status-overdue))] ring-1 ring-[hsl(var(--status-overdue)/0.18)]",
    accent: "bg-[hsl(var(--status-overdue))]",
    text: "text-[hsl(var(--status-overdue))]",
  },
  due_soon: {
    label: "Due soon",
    icon: AlertTriangle,
    badge: "bg-[hsl(var(--status-due-soon)/0.14)] text-[hsl(var(--status-due-soon))] ring-1 ring-[hsl(var(--status-due-soon)/0.20)]",
    accent: "bg-[hsl(var(--status-due-soon))]",
    text: "text-[hsl(var(--status-due-soon))]",
  },
  upcoming: {
    label: "Upcoming",
    icon: Clock,
    badge: "bg-[hsl(var(--status-upcoming)/0.12)] text-[hsl(var(--status-upcoming))] ring-1 ring-[hsl(var(--status-upcoming)/0.18)]",
    accent: "bg-[hsl(var(--status-upcoming))]",
    text: "text-[hsl(var(--status-upcoming))]",
  },
  renewed: {
    label: "Renewed",
    icon: Archive,
    badge: "bg-muted text-muted-foreground ring-1 ring-border",
    accent: "bg-border",
    text: "text-muted-foreground",
  },
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return format(parseISO(iso), "MMM d, yyyy");
  } catch (e) {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return format(parseISO(iso), "MMM d, yyyy 'at' h:mm a");
  } catch (e) {
    return iso;
  }
};

export const daysLabel = (item) => {
  if (item.renewed) return "Archived";
  const d = item.days_remaining;
  if (d === null || d === undefined) return "";
  if (d < 0) return `${Math.abs(d)} day${Math.abs(d) !== 1 ? "s" : ""} overdue`;
  if (d === 0) return "Due today";
  return `${d} day${d !== 1 ? "s" : ""} left`;
};
